const homeBn = {
  hero: {
    title: 'গ্রামীণ বাজারে স্বাগতম',
    subtitle: 'আপনার প্রয়োজনীয় পণ্য খুঁজুন'
  },
  search: {
    placeholderDefault: 'পণ্য খুঁজুন...',
    typewriterPlaceholders: ['চাচকৈড় বাজার', 'মনোহারি দোকান', 'আলিম স্টোর', 'পুই শাক']
  },
  partners: {
    heading: 'আমাদের অংশীদার',
    subheading: 'বিশ্বস্ত প্রতিষ্ঠানের সাথে আমাদের সহযোগিতা'
  }
};

export default homeBn;


